import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import i18n from './i18n';
import VeeValidate from 'vee-validate';

Vue.config.productionTip = false;
Vue.use(VeeValidate);


import TouchKeyboardBp from "@/components/TouchKeyboardBp";
Vue.component("TouchKeyboardBp", TouchKeyboardBp);

import VueTouchKeyboard from "vue-touch-keyboard";
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style

console.log(VueTouchKeyboard.layouts);

// VueTouchKeyboard.layouts
import Layouts from "@/helper/layouts";
VueTouchKeyboard.layouts = Object.assign(VueTouchKeyboard.layouts, Layouts);

// global.sharedObject = {prop1: process.argv};

Vue.use(VueTouchKeyboard);


Vue.prototype.$eventBus = new Vue(); // Global event bus

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
